import { Environments } from "@apply4u/shared/enums/environments";

export const environment = {
  production: true,
  BaseUrl:'https://api.apply4u.co.uk/',
  HostName:'https://www.apply4u.co.uk',
  clientSideBaseUrl:'https://www.apply4u.co.uk/',
  EnvironmentId: Environments.Live,
  TransmitterApiBaseUrl: 'https://transmitter.apply4u.co.uk/',
  IdentityServerUrl : 'https://secure.apply4u.co.uk/',
  appInsights: {
    instrumentationKey: 'd8413f3c-6a11-47ad-bc49-84e7ba3c91e2',
    isEnabled:true
  }
};
